import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useGetTeacherEvaluationsQuery, useGetTeacherEvaluationsReportQuery } from "../../hooks/useGetTeacherEvaluationsQuery";
import { Box, Button, Flex, Heading, Spinner } from "@radix-ui/themes";
import { EmptyState, ErrorState } from "../../components/common/EmptyState";
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import TeacherEvaluationSummary from "./ReportsCards/TeacherEvaluationSummary";
import ClassificationDistributionChart from "./ReportsCards/ClassificationDistributionChart ";
import TrendOverYearsChart from "./ReportsCards/TrendOverYearsChart";
import CriteriaScoresTable from "./ReportsCards/CriteriaScoresTable";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { useAppDispatch } from "../../hooks/hooks";
import { resetTeacherData, resetUpdateTeachertData } from "../../redux/slices/school/teacher";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";

export const TeacherEvaluations = () => {
  const teacherData = useSelector((state: RootState) => state.teacher.teacher);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    data: teacherEvaluationsReport,
    isLoading: isLoadingTeacherEvaluationsReport,
    isError: isErrorTeacherEvaluationsReport,
    refetch: refreshTeacherEvaluationsReport
  } = useGetTeacherEvaluationsReportQuery({
    PageNumber: 1,
    PageSize: 400,
    IdTeacher: teacherData?.id
  }, {
    enabled: !!teacherData?.id
  });

  const handleBack = () => {
    dispatch(resetTeacherData());
    dispatch(resetUpdateTeachertData());
    navigate(routes.teachers);
  }

  if (isLoadingTeacherEvaluationsReport)
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner loading />
      </Flex>
    );

  if (isErrorTeacherEvaluationsReport)
    return (
      <ErrorState
        title="Erro ao carregar o relatório"
        description="Não foi possível obter as avaliações do docente. Por favor, tente novamente."
        onRetry={() => refreshTeacherEvaluationsReport()}
      />
    );

  if (!teacherEvaluationsReport)
    return (
      <EmptyState
        title="Sem avaliações"
        description="Não existem dados de avaliação disponíveis para o docente seleccionado."
      />
    );
    const { summary, classificationDistributions, trendOverYears, criteriaScores } = teacherEvaluationsReport;


    return (
  <Flex direction='column' gap='2'>

    
      <Box>
        <Heading as="h1"  weight="bold" mb="4">
          Relatório de Avaliações do docente
        </Heading>
  
        <Box mb="6">
          <TeacherEvaluationSummary summary={summary} />
        </Box>
  
        <Flex gap="6" wrap="wrap">
          <Box width="100%" maxWidth="600px">
            {classificationDistributions?.length > 0 ? (
              <ClassificationDistributionChart data={classificationDistributions} />
            ) : (
              <EmptyState
                title="Sem distribuição de classificações"
                description="Ainda não há classificações suficientes para apresentar a distribuição."
              />
            )}
          </Box>
  
          <Box width="100%" maxWidth="600px">
            {trendOverYears?.length > 0 ? (
              <TrendOverYearsChart data={trendOverYears} />
            ) : (
              <EmptyState
                title="Sem tendência disponível"
                description="Ainda não existem avaliações de anos anteriores para comparar."
              />
            )}
          </Box>
        </Flex>
  
        <Box mt="6">
          {criteriaScores?.length > 0 ? (
            <CriteriaScoresTable data={criteriaScores} />
          ) : (
            <EmptyState
              title="Sem pontuações por critério"
              description="Ainda não foram registadas pontuações para os critérios de avaliação."
            />
          )}
        </Box>
      </Box>


     <Flex direction='row' gap='3' justify='end'>
                    <Button type="button" variant='soft' color='gray'
                      onClick={handleBack}
                    >
                      <ChevronLeftIcon /> Voltar
                    </Button>

                  </Flex>
  </Flex>
      

    );
};
